import { base44 } from '@/api/base44Client';
import { getDeviceType } from '@/lib/deviceType';

const getSessionId = () => {
  let sessionId = sessionStorage.getItem('baselmitkindern_session');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('baselmitkindern_session', sessionId);
  }
  return sessionId;
};

export function useAnalytics() {
  const trackEvent = async (eventType, data = {}) => {
    try {
      await base44.entities.Analytics.create({
        event_type: eventType,
        session_id: getSessionId(),
        device_type: getDeviceType(),
        page_url: window.location.href,
        referrer: document.referrer,
        ...data
      });
    } catch (e) {
      console.error('Analytics tracking error:', e);
    }
  };

  const trackActivityView = (activityId, regionId, categoryId) => {
    trackEvent('activity_view', { activity_id: activityId, region_id: regionId, category_id: categoryId });
  };

  const trackAffiliateClick = (activityId, partnerId) => {
    trackEvent('affiliate_click', { activity_id: activityId, partner_id: partnerId });
  };

  const trackFavoriteSave = (activityId) => {
    trackEvent('favorite_save', { activity_id: activityId });
  };

  const trackPlannerSubmit = (filterValues, userPreferences) => {
    trackEvent('planner_submit', { filter_values: filterValues, user_preferences: userPreferences });
  };

  const trackNewsletterSignup = (regionId) => {
    trackEvent('newsletter_signup', { region_id: regionId });
  };

  const trackSearch = (query, resultCount) => {
    trackEvent('search', { filter_values: { query, result_count: resultCount } });
  };

  const trackFilterUse = (filterValues) => {
    trackEvent('filter_use', { filter_values: filterValues });
  };

  const trackActivityShare = (activityId, channel) => {
    trackEvent('share', { activity_id: activityId, filter_values: { channel } });
  };

  return {
    trackEvent,
    trackActivityView,
    trackAffiliateClick,
    trackFavoriteSave,
    trackPlannerSubmit,
    trackNewsletterSignup,
    trackSearch,
    trackFilterUse,
    trackActivityShare
  };
}

export default useAnalytics;